<template>
<div class="content-body tenant-settings">
    <div class="">

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane key="bank" label="银行" name="bank">
                <bank-tab ref="bank"></bank-tab>
            </el-tab-pane>
            <el-tab-pane key="factory" label="工厂" name="factory">
                <factory-tab ref="factory"></factory-tab>
            </el-tab-pane>
            <el-tab-pane key="payCondition" label="支付条件" name="payCondition">
                <pay-condition-tab ref="payCondition"></pay-condition-tab>
            </el-tab-pane>
            <el-tab-pane key="province" label="省份" name="province">
                <province-tab ref="province"></province-tab>
            </el-tab-pane>
            <el-tab-pane key="purchaseOrg" label="采购组织" name="purchaseOrg">
                <purchase-org-tab ref="purchaseOrg"></purchase-org-tab>
            </el-tab-pane>
            <el-tab-pane key="purchaseType" label="采购类型" name="purchaseType">
                <purchase-type-tab ref="purchaseType"></purchase-type-tab>
            </el-tab-pane>
            <el-tab-pane key="storePosition" label="存储位置" name="storePosition">
                <store-position-tab ref="storePosition"></store-position-tab>
            </el-tab-pane>
            <el-tab-pane key="taxCode" label="税码" name="taxCode">
                <tax-code-tab ref="taxCode"></tax-code-tab>
            </el-tab-pane>
            <el-tab-pane key="unit" label="单位" name="unit">
                <unit-tab ref="unit"></unit-tab>
            </el-tab-pane>
            <el-tab-pane key="applianceType" label="通用器具类型" name="applianceType">
                <appliance-type-tab ref="applianceType"></appliance-type-tab>
            </el-tab-pane>
            <el-tab-pane key="expressCompany" label="快递公司配置" name="expressCompany">
                <express-company-tab ref="expressCompany"></express-company-tab>
            </el-tab-pane>
            <el-tab-pane key="moveType" label="移动类型" name="moveType">
                <move-type-tab ref="moveType"></move-type-tab>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import BankTab from './bank-tab'
import factoryTab from './factory-tab'
import payConditionTab from './pay-condition-tab'
import provinceTab from './province-tab'
import purchaseOrgTab from './purchase-org-tab'
import purchaseTypeTab from './purchase-type-tab'
import storePositionTab from './store-position-tab'
import taxCodeTab from './tax-code-tab'
import unitTab from './unit-tab'
import applianceTypeTab from './appliance-type-tab'
import expressCompanyTab from './express-company-tab'
import moveTypeTab from './move-type-tab'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            activeName:''
        }
    },
    components: {
        BankTab,
        factoryTab,
        payConditionTab,
        provinceTab,
        purchaseOrgTab,
        purchaseTypeTab,
        storePositionTab,
        taxCodeTab,
        unitTab,
        applianceTypeTab,
        expressCompanyTab,
        moveTypeTab
    },
    mounted(){
        this.activeName = 'bank'
        this.$refs[this.activeName].getDataList()
    },
    methods: {
        handleClick(tab) {
            this.$refs[this.activeName].getDataList()
        }
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
